<template>
  <div class="notification-table-wrapper">
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search notifications"
      single-line
      hide-details
      class="mb-4"
    />
    <v-data-table
      :headers="headers"
      :items="allNotifications"
      :search="search"
      :items-per-page="5"
      class="elevation-1 notification-table"
    >
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.data.imageUrl="{ item }">
      <img
        v-if="item.data.imageUrl"
        :src="item.data.imageUrl"
        alt="Notification Image"
        width="50"
        class="notification-image clickable-image"
        @click.stop="showNotification(item)"
        style="cursor:pointer"
      >
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.timestamp="{ item }">
      {{ new Date(item.timestamp).toLocaleString() }}
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.delete="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            medium
            color="rgb(171, 32, 32)"
            class="delete-icon"
            @click="confirmDelete(item._id)"
          >
            mdi-delete
          </v-icon>
        </template>
        <span>Delete</span>
      </v-tooltip>
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.resend="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            medium
            color="rgb(32, 120, 171)"
            class="resend-icon"
            @click="resendNotification(item)"
          >
            mdi-send
          </v-icon>
        </template>
        <span>Resend</span>
      </v-tooltip>
    </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="500px">
      <ShowNotification
        v-if="selectedNotification"
        :notification="selectedNotification"
        @close="dialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import ShowNotification from './ShowNotification.vue';

export default {
  name: "NotificationHistory",
  data() {
    return {
      headers: [
        { text: 'Image', value: 'data.imageUrl', sortable: false },
        { text: 'Title', value: 'title' },
        { text: 'Body', value: 'body' },
        { text: 'Date', value: 'timestamp' },
        { text: 'Delete', value: 'delete', sortable: false, align: 'center' },
        { text: 'Resend', value: 'resend', sortable: false, align: 'center' },
      ],
      dialog: false,
      selectedNotification: null,
      search: '',
    };
  },
  computed: {
    ...mapGetters('notifications', ['allNotifications']),
  },
  methods: {
    ...mapActions('notifications', ['fetchNotifications', 'deleteNotification', 'resendNotification']),
    showNotification(item) {
      this.selectedNotification = item;
      this.dialog = true;
    },
    confirmDelete(notificationId) {
      this.$buefy.dialog.confirm({
        title: 'Deleting notification',
        message: 'Are you sure you want to <b>delete</b> this notification? This action cannot be undone.',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.deleteNotification(notificationId);
        }
      });
    },
    resendNotification(item) {
      const now = new Date().toLocaleString();
      const message = `
        <div style='display:flex;align-items:center;gap:10px;'>
          ${item.data && item.data.imageUrl ? `<img src='${item.data.imageUrl}' alt='Notification Image' style='width:40px;height:40px;object-fit:cover;border-radius:4px;'>` : ''}
          <div>
            <div><strong>Title:</strong> ${item.title}</div>
            <div><strong>Body:</strong> ${item.body}</div>
            <div><strong>Current time:</strong> ${now}</div>
          </div>
        </div>
        <div style='margin-top:10px;'>Do you want to resend this notification now?</div>
      `;
      this.$buefy.dialog.confirm({
        title: 'Resend notification',
        message,
        confirmText: 'Resend',
        type: 'is-info',
        hasIcon: false,
        dangerouslyUseHTMLString: true,
        onConfirm: () => {
          this.$store.dispatch('notifications/resendNotification', item);
        }
      });
    }
  },
  created() {
    this.fetchNotifications();
  },
  components: {
    ShowNotification
  }
};
</script>

<style scoped>
.notification-history {
  border: 1px solid #ccc;
  padding: 60px;
  border-radius: 10px;
  height: 100%;
  overflow-y: auto;
}
.notification-image {
  border-radius: 5px;
  margin: 5px 0;
}
.clickable-image {
  transition: box-shadow 0.2s;
}
.clickable-image:hover {
  box-shadow: 0 0 0 2px #1976d2;
}
.delete-icon {
  color: rgb(171, 32, 32);
}

.notification-table-wrapper {
  max-width: 1000px;
  margin: 0 auto;
}
.notification-table {
  min-width: 600px;
}
</style>